import { Link } from "gatsby";
import React, { useState } from "react";
import MessageSvg from "assets/images/FreeQuote.svg";
import MessageSvgHover from "assets/images/FreeQuote_hover.svg";
// import EmailSvg from "assets/images/Email.png";
import EmailSvg from "assets/images/cta_email.svg";
import EmailSvgHover from "assets/images/cta_email_hover.svg";
// import CallUsSvg from "assets/images/CallUs.png";
import CallUsSvg from "assets/images/cta_call.svg";
import CallUsSvgHover from "assets/images/cta_call_hover.svg";

export default function EmailerLocation() {
  const [hoverMessage, setHoverMessage] = useState(false);
  const [hoverEmail, setHoverEmail] = useState(false);
  const [hoverCallus, setHoverCallus] = useState(false);

  return (
    <>
      <section className="bg-midBlue py-16">
        <div className="max-w-6xl mx-auto">
          <div className="lg:grid grid-cols-3 mlap:px-6  mmob:px-2">
            <div className="my-6 block lg:inline-block text-center">
              <Link to="/quote">
                <div className="w-300 h-full inline-block mlap:w-200 mx-auto  lg:my-0" onMouseEnter={() => setHoverMessage(true)} onMouseLeave={() => setHoverMessage(false)}>
                  <img src={!hoverMessage ? MessageSvg : MessageSvgHover} alt="message" />
                </div>
              </Link>
            </div>
            <div className="my-6 block lg:inline-block text-center">
              <a href="mailto:support@tomedes.com">
                <div className="w-300 h-full inline-block mx-auto  lg:my-0" onMouseEnter={() => setHoverEmail(true)} onMouseLeave={() => setHoverEmail(false)}>
                  <img src={!hoverEmail ? EmailSvg : EmailSvgHover} alt="email" />
                </div>
              </a>
            </div>
            <div className="my-6 block lg:inline-block text-center">
              <a href="tel:+19852390142">
                <div className=" w-300 h-full inline-block mx-auto  lg:my-0" onMouseEnter={() => setHoverCallus(true)} onMouseLeave={() => setHoverCallus(false)}>
                  <img src={!hoverCallus ? CallUsSvg : CallUsSvgHover} alt="callus" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
